<mat-card>
  <mat-card-content>
    @if (smartsafeStatus.online == true) {
      <span id="network-health-badge-green">
        <mat-icon matTooltip="Health: good" matTooltipPosition="right">network_check</mat-icon>
      </span>
    }
    @if (smartsafeStatus.online == false) {
      <span id="network-health-badge-red">
        <mat-icon matTooltip="Health: bad" matTooltipPosition="right">network_check</mat-icon>
      </span>
    }
    @if (smartsafeStatus.online == undefined) {
      <p><b>Status:</b> Unknown</p>
    }
    @if (smartsafeStatus.online == true) {
      <p><b>Status:</b> Online</p>
    }
    @if (smartsafeStatus.online == false) {
      <p><b>Status:</b> Offline</p>
    }
    @if (smartsafe) {
      <span>
        <!-- <mat-divider></mat-divider> -->
        <p><b>Mac:</b> {{smartsafe.mac}}</p>
        <p><b>IPv4 Address:</b> {{smartsafe.ip}}</p>
        <p><b>Switch:</b> {{smartsafe.recentDeviceName}}</p>
        <p><b>Port:</b> {{smartsafe.switchport}}</p>
        <p><b>ID:</b> {{smartsafe.id}}</p>
      </span>
    }
  </mat-card-content>
</mat-card>